const AlumniData = [
  {
    key: 1,
    name: "Nitish Kumar",
    profession: "(Chief Minister of Bihar)",
    image: "https://alumini-nitp.vercel.app/notable-alumni/nitish-kumar.webp",
    discription:
      "Nitish Kumar is an Indian politician who has been the Chief Minister of Bihar, a state in eastern India, since 2017. Previously he served as the Chief Minister of Bihar from 2005 to 2014 and from 2015 to 2017.",
  },
  {
    key: 2,
    name: "Manas Bihari Verma",
    profession: "(Scientist)",
    image:
      "https://alumini-nitp.vercel.app/notable-alumni/manas-bihari-verma.jpg",
    discription:
      "Manas Bihari Verma was an Indian aeronautical scientist instrumental in the development of the light combat aircraft, Tejas. In 2018, he was conferred the Padma Sri civilian honour by the President of India.",
  },

  {
    key: 3,

    name: "Dr. Ratan Kumar Sinha",

    profession: "(Former Chairman, Atomic Energy Commission)",

    image:
      "https://alumini-nitp.vercel.app/notable-alumni/Ratan_Kumar_Sinha.jpg",

    discription:
      "Dr. Ratan Kumar Sinha is an Indian nuclear scientist who served as the chairman of the Atomic Energy Commission of India and the Secretary to the Government of India, Department of Atomic Energy from 2012 to 2015.",
  },
];

export default AlumniData;
